import backend, {AGENTCORE_ENGINE_API} from 'utils/backend/server/api_library';

import queryString from 'query-string';

const getCase = (caseRn) => {
  const url = `${AGENTCORE_ENGINE_API}/case/${caseRn}`;
  return backend.get(url);
};

const queryCase = (filters, sort, lastEvaluatedKey) => {
  const queryParam = {
    lastEvaluatedKey,
  };

  if (filters) {
    queryParam.filters = JSON.stringify(filters);
  }

  if (sort) {
    queryParam.sort = JSON.stringify(sort);
  }

  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});
  const url = `${AGENTCORE_ENGINE_API}/case?${query}`;
  return backend.get(url);
};

const queryCaseFromDate = (date, filters, sort, lastEvaluatedKey) => {
  const queryParam = {
    date,
    lastEvaluatedKey,
  };

  if (filters) {
    queryParam.filters = JSON.stringify(filters);
  }

  if (sort) {
    queryParam.sort = JSON.stringify(sort);
  }

  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});
  const url = `${AGENTCORE_ENGINE_API}/case/date?${query}`;
  return backend.get(url);
};

const updateStatus = (caseRn, status) => {
  const url = `${AGENTCORE_ENGINE_API}/case/${caseRn}/status`;
  const body = {
    status,
  };

  return backend.put(url, body);
};

const updatePriority = (caseRn, priority) => {
  const url = `${AGENTCORE_ENGINE_API}/case/${caseRn}/priority`;
  const body = {
    priority,
  };

  return backend.put(url, body);
};

const createActionLog = (caseRn, message) => {
  const url = `${AGENTCORE_ENGINE_API}/case/${caseRn}/action_log`;
  const body = {
    message,
  };

  return backend.post(url, body);
};

const getCaseMarks = (caseRn) => {
  const url = `${AGENTCORE_ENGINE_API}/case/${caseRn}/marks`;
  return backend.get(url);
};

const createReview = (caseRn, review) => {
  const url = `${AGENTCORE_ENGINE_API}/case/${caseRn}/review`;
  const body = {
    grade: review.grade,
    failureCategory: review.failureCategory,
    reasoning: review.reasoning,
    goldenSet: review.goldenSet,
  };

  return backend.post(url, body);
};

export default {
  getCase,
  getCaseMarks,
  createReview,
  queryCase,
  queryCaseFromDate,
  updateStatus,
  updatePriority,
  createActionLog,
};
